<mat-dialog-content>
  <t4-container title="{{ 'Turbo.Settings.EditLocationUser.Headline' | translate : 'Edit employee' }}">
    <div class="row">
      <div class="col-xs-6">
        <mat-form-field style="width: 100%;">
          <input type="text" #txtFirstname="ngModel" matInput placeholder="{{ 'Turbo.Settings.EditLocationUser.tipFirstname' | translate : 'First name' }}" required [(ngModel)]="user.Firstname" />
        </mat-form-field>
      </div>
      <div class="col-xs-6">
        <mat-form-field style="width: 100%;">
          <input #txtLastname="ngModel" type="text" matInput placeholder="{{ 'Turbo.Settings.EditLocationUser.tipLastname' | translate : 'Last name' }}" required [(ngModel)]="user.Lastname" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-6">
        <mat-form-field style="width: 100%;">
          <input type="text" #txtPinCode="ngModel" matInput placeholder="{{ 'Turbo.Settings.EditLocationUser.tipPin' | translate : 'Pin code' }}" required [(ngModel)]="user.PinCode" />
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-6">
        <mat-form-field style="width: 100%;">
          <input type="text" matInput placeholder="{{ 'Turbo.Settings.EditLocationUser.tipPhone' | translate : 'Phone' }}" [(ngModel)]="user.Phone" />
        </mat-form-field>
      </div>
      <div class="col-xs-6">
        <mat-form-field style="width: 100%;">
          <input type="email" #txtEmail="ngModel" matInput placeholder="{{ 'Turbo.Settings.EditLocationUser.tipEmail' | translate : 'Email' }}" [(ngModel)]="user.Email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" />
        </mat-form-field>
      </div>
    </div>
  </t4-container>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button color="primary" style="margin: 5px;" (click)="save()">{{ 'Turbo.Settings.EditLocationUser.cmdSave' | translate : 'Save' }}</button>
    <button mat-button style="margin: 5px;" [mat-dialog-close]>{{ 'Turbo.Settings.EditLocationUser.cmdCancel' | translate : 'Cancel' }}</button>
  </mat-dialog-actions>
